$.fn.stickyTableOfContent = function(menu_selector) {
  let self = this

  self.checkPosition = function() {
    var scrollTop = $(window).scrollTop(),
    elementOffset = self.offset().top,
    distance = (elementOffset - scrollTop);
    bottom_limit = (self.outerHeight() - self.find(menu_selector).outerHeight()) * -1;
    if (distance - 160 < bottom_limit) {
      self.removeClass('--fixed');
      self.addClass('--fixed-bottom');
    } else if (distance < 160 && distance > bottom_limit) {
      self.removeClass('--fixed-bottom');
      self.addClass('--fixed');
    } else {
      self.removeClass('--fixed');
      self.removeClass('--fixed-bottom');
    }
  }

  return function() {
    $(window).on('load resize orientationchange scroll', self.checkPosition)
    self.checkPosition()
    return self
  }()
}

$.fn.linkTableOfContent = function(content_selector) {
  let self = this

  self.find('a').each(function() {
    var id = $(this).attr('href')
    $(id).addClass('js-anchor');
  });
  checkSelected();

  $(window).scroll(function(){
    checkSelected();
  });

  $(window).on('load resize orientationchange', function(the_event) {
    checkSelected();
  })

  function checkSelected() {
    $('.js-anchor').each(function() {
      var scrollTop = $(window).scrollTop(),
      elementOffset = $(this).offset().top - ($(window).height() / 3),
      distance = (elementOffset - scrollTop)
      if (distance < 180) {
        self.find('.--selected').removeClass('--selected')
        self.find('a[href=#' + $(this).attr('id') + ']').addClass('--selected')
        self.find('a[href=#' + $(this).attr('id') + ']').parent().addClass('--selected')
      }
    });
    if (self.find('a.--selected').length <= 0) {
      self.find('a').first().addClass('--selected')
    }
  }

  self.find('a').click(function() {
    let hash = $(this).attr('href'),
    targetElement = $(hash),
    targetTop = targetElement.offset().top - $('.header-wrapper').outerHeight(false) - 32
    if ($('.product-bar').length) {
      targetTop -= $('.product-bar').outerHeight(false)
    }
    $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
    return false;
  })

  return function() {
    return self
  }()
};
